import styled from 'styled-components';
import BackgroundImage from 'common/BackgroundImage';

const StyledBackgroundImage = styled(BackgroundImage)`
    top: calc((100vh - min(450px, 45vw)) * 0.5);
`;

export default StyledBackgroundImage;
